<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-chart-box
      </v-icon> Tax Rates
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="createTaxRate()"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Tax Rate
        </v-btn>
      </v-col>
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              dense
              label="Search"
              append-icon="mdi-magnify"
              outlined
            />
          </v-col>
          <v-spacer />
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="taxRates"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>
              {{ CountryCodeList[item.country] }}
            </td>
            <td>{{ item.name }}</td>
            <td>
              <font v-if="item.description === null">
                N/A
              </font>
              <font v-else>
                {{ item.description }}
              </font>
            </td>
            <td>
              {{ item.percentage }}%
            </td>
            <td>
              {{ item.inclusive | taxIncluded }}
            </td>
            <td>
              <font
                :color="getColor(item.active)"
                class="font-my-style"
              >
                {{ item.active | statusUpdate }}
              </font>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <create-Tax-Rate
      v-if="showForm"
      @closed="showForm=false"
      @fetch-tax-rates="fetchTaxRates()"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import CreateTaxRate from 'src/views/dashboard/payments/taxrates/CreateTaxRate.vue';

  export default {
    name: 'Products',
    components: {
      'centre-spinner': spinner,
      'create-Tax-Rate': CreateTaxRate,
    },
    filters: {
      statusUpdate (active) {
        if (active === true) {
          return 'Active*';
        } else {
          return 'Inactive';
        }
      },
      taxIncluded (taxIncluded) {
        if (taxIncluded === true) {
          return 'Inclusive';
        } else {
          return 'Exclusive';
        }
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Country', value: 'country' },
          { text: 'Tax Name', align: 'start', value: 'name' },
          { text: 'Tax description', value: 'description' },
          { text: 'Tax Percentage', value: 'percentage' },
          { text: 'Tax Addition', value: 'inclusive' },
          { text: 'Status', value: 'status' },
        ],
        showForm: false,
      };
    },
    computed: {
      taxRates () {
        return this.$store.getters['payments/getTaxRates'];
      },
      CountryCodeList () {
        return this.$store.getters['users/getCountryCodes'];
      },
    },
    async mounted () {
      this.loading = true;
      await this.getCountryCodes();
      await this.fetchTaxRates();
      this.loading = false;
    },
    methods: {
      async fetchTaxRates () {
        await this.$store.dispatch('payments/fetchTaxRates');
      },
      getColor (status) {
        if (status === true) {
          return '#2E7D32';
        } else {
          return '#C62828';
        }
      },
      async getCountryCodes () {
        await this.$store.dispatch('users/fetchCountryCodes');
      },
      createTaxRate () {
        this.showForm = true;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
.font-my-style {
  font-weight: bold;
}
.font-my-style {
  font-weight: bold;
}
</style>
